import { render, staticRenderFns } from "./2TypeOfCoverage.vue?vue&type=template&id=07f4dddb"
import script from "./2TypeOfCoverage.vue?vue&type=script&lang=js"
export * from "./2TypeOfCoverage.vue?vue&type=script&lang=js"
import style0 from "./2TypeOfCoverage.vue?vue&type=style&index=0&id=07f4dddb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports